import React, { createContext, useContext } from 'react';

const ShellChromeContext = createContext({ titleOwned: false });

export function ShellChromeProvider({ titleOwned = false, children }) {
  return (
    <ShellChromeContext.Provider value={{ titleOwned: Boolean(titleOwned) }}>
      {children}
    </ShellChromeContext.Provider>
  );
}

export function useShellChrome() {
  return useContext(ShellChromeContext);
}

export default ShellChromeContext;
